import React from "react";
import "../css/dashboard.css";
import Navbar from "../component/Navbar";

import { useNavigate } from "react-router-dom";
import { useMediaQuery } from "react-responsive";
import { IconButton } from "@mui/material";
import MenuIcon from "@mui/icons-material/Menu";

import MobileAppSetContent from "./MobileAppSetContent";
import MobileAppSetContentMobile from "./MobileAppSetContentMobile";

export default function MobileAppSettings() {
  const navigate = useNavigate();

  const handleMenuOpen = () => {
    navigate("/menumobile");
  };

  const isMobile = useMediaQuery({ query: "(max-width: 800px)" });
  return (
    <div className="main-container">
      {isMobile ? (
        <>
          <div className="menu-button-container">
            <IconButton
              edge="start"
              color="inherit"
              aria-label="menu"
              onClick={handleMenuOpen}
              className="menu-button"
            >
              <MenuIcon />
            </IconButton>
          </div>

          <MobileAppSetContentMobile />
        </>
      ) : (
        <>
          <Navbar linkActive={19} />
          <MobileAppSetContent />
        </>
      )}
    </div>
  );
}
